function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 11.5,
  cy: 13.499,
  r: 8.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23 3.995c-5.56 0-10.33-3.74-10.38-3.78a1 1 0 0 0-1.24 0c-.05.04-4.8 3.78-10.38 3.78a1 1 0 0 0-1 1V14c0 6.71 2.71 10 11.59 13.912a1 1 0 0 0 .82 0C21.29 24.001 24 20.71 24 14V4.996a1 1 0 0 0-1-1ZM12 21a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.331 10.472a1 1 0 0 1 1.756.951l-.056.103-3.681 5.94a1 1 0 0 1-1.56.178l-.085-.097-2.34-3.065a1 1 0 0 1 1.507-1.309l.083.095 1.458 1.912 2.918-4.708Z",
  fill: "currentColor"
});

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.4d8e6e61.svg";
export { ForwardRef as ReactComponent };